<template>
    <div>
        <kn-jumbotron></kn-jumbotron>
        <b-container fluid class="px-4 pb-5">
            <b-row class="justify-content-center mx-auto" style="max-width: 1400px;">
                <kn-sideMenu></kn-sideMenu>

                <main role="main" class="col-md-9 pl-md-5">
                    <div class="content-card">
                        <h2 class="section-title">
                            <span class="blue-accent"></span>Επικοινωνήστε Μαζί μας:
                        </h2>

                        <b-row class="mt-4">
                            <b-col cols="12" md="6" class="mb-4">
                                <div class="contact-info-block">
                                    <h5 class="info-heading"><i class="fa-solid fa-person mr-2"></i> Ιδρυτής -
                                        Ιδιοκτήτης:</h5>
                                    <p class="info-text">Γεράσιμος - Θεόδωρος Μαγκανιώτης</p>
                                </div>

                                <div class="contact-info-block">
                                    <h5 class="info-heading"><i class="fa-solid fa-person-dress mr-2"></i> Εκδότρια -
                                        Ιδιοκτήτρια:</h5>
                                    <p class="info-text">Σοφία Μαγκανιώτη</p>
                                </div>
                            </b-col>

                            <b-col cols="12" md="6" class="mb-4">
                                <div class="contact-info-block">
                                    <h5 class="info-heading"><i class="fa-solid fa-envelope mr-2"></i> Διεύθυνση:</h5>
                                    <p class="info-text">Ευξείνου Πόντου 161, Νέα Σμύρνη, 17123</p>
                                </div>

                                <div class="contact-info-block">
                                    <h5 class="info-heading"><i class="fa-solid fa-at mr-2"></i> Email:</h5>
                                    <p class="info-text">
                                        <a href="mailto:kimoliakanea@gmail.com"
                                            class="email-link">kimoliakanea@gmail.com</a>
                                    </p>
                                </div>

                                <div class="contact-info-block">
                                    <h5 class="info-heading"><i class="fa-solid fa-square-phone mr-2"></i> Τηλέφωνο:
                                    </h5>
                                    <p class="info-text">(+30) 210 9370430</p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </main>
            </b-row>
        </b-container>
        <kn-footer></kn-footer>
    </div>
</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import footer from "./footer.vue";

export default {
    components: {
        "kn-jumbotron": jumbotron,
        "kn-sideMenu": sideMenu,
        "kn-footer": footer
    }
};
</script>

<style lang="scss" scoped>
.content-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
    padding: 2.5rem;
    margin-bottom: 2rem;
    border-top: 5px solid #0284c7;
}

.section-title {
    display: flex;
    align-items: center;
    font-size: 1.75rem;
    color: #0c4a6e;
    border: none;
    margin-bottom: 1.5rem;
    font-weight: 700;
}

.blue-accent {
    background: #0ea5e9;
    display: inline-block;
    width: 6px;
    height: 28px;
    margin-right: 12px;
    border-radius: 4px;
}

.contact-info-block {
    margin-bottom: 2rem;
    background: #f8fafc;
    padding: 1.5rem;
    border-radius: 12px;
    border-left: 4px solid #0284c7;
    box-shadow: 0 2px 4px rgba(2, 132, 199, 0.05);
    transition: all 0.3s ease;
}

.contact-info-block:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 6px rgba(2, 132, 199, 0.1);
    background: #ffffff;
}

.info-heading {
    color: #0c4a6e;
    font-weight: 700;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
}

.info-text {
    color: #334155;
    font-size: 1.1rem;
    margin: 0;
    padding-left: 2rem;
}

.email-link {
    color: #0284c7;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
}

.email-link:hover {
    color: #0c4a6e;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue